import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as changeRequestApi from "../../api/workOrderApi/changeRequestApi";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {
  EQChangeRequest,
  initializeChangeRequest,
} from "../../models/serverModels/workOrder/EQChangeRequest";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import ChangeRequestForm from "./ChangeRequestForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {changeRequestSchema} from "../../validation/changeRequestSchema";

const CreateChangeRequest = () => {
  const {state} = useLocation();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQChangeRequest>,
    Params.Create<EQChangeRequest>
  >({
    api: changeRequestApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/WorkOrder/ChangeRequestList`);
        queryClient.invalidateQueries("ChangeRequestList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQChangeRequest>({
    defaultValues: initializeChangeRequest(),
    resolver: yupResolver(changeRequestSchema),
  });
  const onSubmit: SubmitHandler<EQChangeRequest> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeChangeRequest(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="변경요청서 작성" />
      {isLoading && <MWProgress />}

      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <ChangeRequestForm />
          <ConfirmButtonGroup
            link={`/WorkOrder/ChangeRequestList`}
            cancelText="취소"
            confirmText="추가"
          />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateChangeRequest;
